import React, { useRef } from 'react';

import { Box, xcss, media } from '@atlaskit/primitives';

const endOfPageRecContainerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	paddingBottom: 'space.250',
	margin: 'auto',
	width: '87.5%',
	[media.above.lg]: { maxWidth: '1000px' },
});

const maxWidthStyles = xcss({
	width: 'unset',
	maxWidth: 'unset',
});

export const EndOfPageRecContainer = ({
	children,
	ssrPlaceholderIdProp,
	isDefaultWidth,
}: {
	children: React.ReactNode;
	ssrPlaceholderIdProp: any;
	isDefaultWidth: boolean;
}) => {
	const componentRef = useRef<HTMLDivElement>(null);

	return (
		<Box
			data-testid="test-rec"
			data-vc="end-of-page-recommendation-component"
			ref={componentRef}
			testId="test-rec"
			xcss={[endOfPageRecContainerStyles, !isDefaultWidth && maxWidthStyles]}
			{...ssrPlaceholderIdProp}
		>
			{children}
		</Box>
	);
};
